module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"connected":"Connected {time}","callingTo":"Calling "},"es":{"connected":"Conectado {time}","callingTo":"Llamando a"}}')
  delete Component.options._Ctor
}
